import type {
  CashManagementConfigurableProvider,
  PROVIDER_CLEAR_JUNCTION,
  PROVIDER_IFX_PAYMENTS,
  PROVIDER_ISX_FINANCIAL,
} from "../constants/Provider";
import type { CashManagementProviderCustomerConfig } from "../models/ProviderCustomerConfig";

export function isIFXPayments(
  provider: CashManagementProviderCustomerConfig<CashManagementConfigurableProvider>
): provider is CashManagementProviderCustomerConfig<
  typeof PROVIDER_IFX_PAYMENTS
> {
  return (
    provider.credentials &&
    "username" in provider.credentials &&
    "clientId" in provider.credentials &&
    "clientSecret" in provider.credentials &&
    "password" in provider.credentials &&
    "notificationSecret" in provider.credentials
  );
}

export function isISXFinancial(
  provider: CashManagementProviderCustomerConfig<CashManagementConfigurableProvider>
): provider is CashManagementProviderCustomerConfig<
  typeof PROVIDER_ISX_FINANCIAL
> {
  return (
    !(
      "username" in provider.credentials ||
      "clientId" in provider.credentials ||
      "clientSecret" in provider.credentials ||
      "password" in provider.credentials
    ) && "notificationSecret" in provider.credentials
  );
}

export function isClearJunction(
  provider: CashManagementProviderCustomerConfig<CashManagementConfigurableProvider>
): provider is CashManagementProviderCustomerConfig<
  typeof PROVIDER_CLEAR_JUNCTION
> {
  return !provider.credentials && provider.riskScore;
}
